import { render, staticRenderFns } from "./CertificateDescriptionModal.vue?vue&type=template&id=383941a6&scoped=true"
import script from "./CertificateDescriptionModal.vue?vue&type=script&lang=js"
export * from "./CertificateDescriptionModal.vue?vue&type=script&lang=js"
import style0 from "./CertificateDescriptionModal.vue?vue&type=style&index=0&id=383941a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383941a6",
  null
  
)

export default component.exports